import * as THREE from 'three';
import atlasInfo from './treeAtlas.json';

// Tree billboards. The pictures are real procedural 3D trees (EZ-Tree: branching trunks with bark
// textures and thousands of leaves) rendered once by scripts/bake-trees.js into an atlas of four
// cells side by side:  0: pine   1: fir   2: oak   3: birch.
// treeAtlas.json (written by the same script) holds each billboard's size in metres, so every
// picture is shown with the tree's true proportions.
export const TREE_KINDS = atlasInfo.kinds.map((k) => k.name);
export const TREE_SIZE = Object.fromEntries(atlasInfo.kinds.map((k) => [k.name, k.size]));

// Three crossed vertical quads showing one atlas cell. Normals point outward and up (like a
// rounded crown), so lighting and snow-on-top look natural.
export function makeBillboardGeometry(kindIndex) {
  const [w, h] = TREE_SIZE[TREE_KINDS[kindIndex]];
  const cells = TREE_KINDS.length;
  const u0 = kindIndex / cells, u1 = (kindIndex + 1) / cells;
  const pos = [], nor = [], uv = [], idx = [];
  for (let q = 0; q < 3; q++) {
    const a = (q / 3) * Math.PI;
    const dx = Math.cos(a) * w / 2, dz = Math.sin(a) * w / 2;
    const base = pos.length / 3;
    const corners = [[-dx, 0, -dz, u0, 0], [dx, 0, dz, u1, 0], [dx, h, dz, u1, 1], [-dx, h, -dz, u0, 1]];
    for (const [x, y, z, u, v] of corners) {
      pos.push(x, y, z);
      const n = new THREE.Vector3(x / (w / 2), 0.5 + (y / h) * 1.2, z / (w / 2)).normalize();
      nor.push(n.x, n.y, n.z);
      uv.push(u, v);
    }
    idx.push(base, base + 1, base + 2, base, base + 2, base + 3);
  }
  const g = new THREE.BufferGeometry();
  g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
  g.setAttribute('normal', new THREE.Float32BufferAttribute(nor, 3));
  g.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
  g.setIndex(idx);
  return g;
}
